import { render, staticRenderFns } from "./CardHelp.vue?vue&type=template&id=70403514"
import script from "./CardHelp.vue?vue&type=script&lang=js"
export * from "./CardHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports